import { put, call } from 'redux-saga/effects';
import ExternalSettingsDataRepository from '../../../../data/repositories/ExternalSettingsDataRepository';
import ExternalSettingsRepository from '../../../repositories/ExternalSettingsRepository';
import { Types } from './actions';

const dataByDefault = [
  {
    name: 'Boletín',
    link: 'https://bit.ly/BoLima'
  },
  {
    name: 'Beneficio',
    link: 'https://view.genial.ly/63978d9f7be23c00125f6dd9'
  }
];

export default function* saga(): any {
  try {
    yield put({ type: Types.GET_LINKS_INTEREST_REQUEST });
    const externalSettingsRepository: ExternalSettingsRepository =
      new ExternalSettingsDataRepository();
    const linksInterest = yield call(
      externalSettingsRepository.getLinksInterest
    );

    if (!linksInterest) {
      yield put({
        type: Types.GET_LINKS_INTEREST_SUCCESS,
        data: dataByDefault
      });
      return;
    }
    if (linksInterest.length === 0) {
      yield put({
        type: Types.GET_LINKS_INTEREST_SUCCESS,
        data: dataByDefault
      });
      return;
    }
    yield put({
      type: Types.GET_LINKS_INTEREST_SUCCESS,
      data: linksInterest
    });
    yield put({
      type: Types.GET_LINKS_INTEREST_SUCCESS,
      data: linksInterest
    });
  } catch (error) {
    yield put({
      type: Types.GET_LINKS_INTEREST_FAILURE,
      error:
        'Ocurrió un error al momento de leer datos de Links de interés - Boletín.'
    });
  }
}
